import React from 'react';
import About from '../components/About';

const Entreprises = () => {
    return (
        <div style={{ paddingTop: '80px' }}>
            <About />
        </div>
    );
};

export default Entreprises;
